import { Moment } from 'moment';
import { create } from 'zustand'

interface GeneralUsTreasuryStore {
  usTreasury: [Moment, number[]][],
  setUsTreasury: (usTreasury: [Moment, number[]][]) => void,
}

const useGeneralUsTreasuryStore = create<GeneralUsTreasuryStore>((set) => ({
  usTreasury: [],
  setUsTreasury: (usTreasury: [Moment, number[]][]) => set({ usTreasury }),
}));

export default useGeneralUsTreasuryStore;